<template>
  <div>
    <common-dialog
      ref="dialog"
      width="900px"
      show-save-button
      unit="角色"
      edit-title
      id-key="RoleId"
      form-label-width="110px"
      :data="data"
      :form-rules="rules"
      :get-data-func="api.getRoleWithMenu"
      :before-save="onBeforeSave"
      @create-opened="onCreateOpened"
      :save-func="api.save"
      @edit-opened="onEditOpened"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="$store.state.isMB?24:12">
            <el-form-item label="角色名称" prop="RoleName">
              <el-input v-model="data.RoleName" placeholder="请输入角色名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="$store.state.isMB?24:12">
            <el-form-item label="状态" prop="Status">
              <el-radio-group v-model="data.Status">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="排序" prop="Sort">
          <el-input-number :min="0" v-model="data.Sort"></el-input-number>
        </el-form-item>
        <el-form-item label="描述" prop="Remark">
          <el-input v-model="data.Remark" placeholder="请输入角色备注"></el-input>
        </el-form-item>
        <!-- <el-form-item label="数据阅读权限" prop="DataRange" :class="$store.state.isMB?'setMargin':''">
          <el-radio-group v-model="data.DataRange">
            <el-radio :label="0">所有</el-radio>
            <br v-if="$store.state.isMB" />
            <el-radio :label="1">本部门</el-radio>
            <br v-if="$store.state.isMB" />
            <el-radio :label="2">本部门以及下属部门</el-radio>
          </el-radio-group>
        </el-form-item>-->
        <div v-if="$store.state.isMB" style="margin-bottom:10px;">功能权限操作</div>
        <el-form-item
          :label="$store.state.isMB?'':'功能操作权限'"
          :label-width="$store.state.isMB?'0':''"
        >
          <menu-list ref="menuList" />
        </el-form-item>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import commonDialog from "@/components/common/dialog";
import menuList from "./menuList";
import editDialogMixin from "@/mixins/editDialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    menuList,
  },
  data() {
    return {
      data: {
        RoleId: 0,
        RoleName: "",
        Remark: "",
        Sort: 0,
        Status: 1,
        DataRange: 0,
        Menus: [],
      },
      api: require("@/api/sy/role").default,
      rules: {
        RoleName: [
          { required: true, message: "角色名称不能为空", trigger: "change" },
        ],
      },
    };
  },
  computed: {},
  methods: {
    onCreateOpened() {
      this.api.getRoleWithMenu(0).then((res) => {
        return this.$refs.menuList.setData(res.Data.Menus);
      });
      this.api.getMaxSort().then((res) => {
        this.data.Sort = res.Data;
      });
    },
    onEditOpened(data) {
      return this.$refs.menuList.setData(data.Menus);
    },
    onBeforeSave() {
      let roleMenus = this.$refs.menuList.getCheckedRows();
      this.data.Menus = roleMenus;
      return true;
    },
    onClosed() {
      this.$refs.menuList.reset();
    },
  },
};
</script>
<style lang="scss">
.setMargin {
  .el-form-item__label {
    padding-left: 15px;
  }
  .el-radio {
    margin-bottom: 10px;
  }
}
</style>